import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.page.html',
  styleUrls: ['./feedback.page.scss'],
})
export class FeedbackPage implements OnInit {

  @Input() id: number;
  @Input() feedbackQuestion;
  
  message='';
  stars: number[] = [1, 2, 3, 4, 5];
  selectedValue = [];
  selectedRate = [];
  is_dark_mode = false;
  

  constructor(
    private modalCtrl: ModalController,
    private messageService: MessageService,
    public toastController: ToastController,
    private router:Router
  ) {
    
   }

  ionViewWillEnter(){
    let isDark = localStorage.getItem('dark_mode');
    if(isDark == 'true'){
      this.is_dark_mode = true;
    }else{
      this.is_dark_mode = false;
    }
  }

  ngOnInit() {
    for(let i=0; i<this.feedbackQuestion.length; i++){ 
      let id = this.feedbackQuestion[i].id;
      if(this.feedbackQuestion[i].type == 'rating'){
        this.selectedRate.push(0);        
      }else{
        this.selectedRate.push('yes');    
      }
    }
    console.log(this.selectedValue);
  }

  countStar(star,id) {
    this.selectedRate[id] = star;
  }

  addClass(star,id) {
    let ab = "";
    for (let i = 0; i < star; i++) {
      ab = "starId" +id+ i;
      document.getElementById(ab).classList.add("selected");
    }
  }
  removeClass(star,id) {
    let ab = "";
    for (let i = star-1; i >= this.selectedRate[id]; i--) {
      ab = "starId" +id+ i;
      document.getElementById(ab).classList.remove("selected");
    }
  }

  sendFeedback(){
    this.selectedValue = [];
    for(let i=0; i<this.feedbackQuestion.length; i++){ 
      let id = this.feedbackQuestion[i].id;
      const final = {id:id, value:this.selectedRate[i], type:this.feedbackQuestion[i].type}
      this.selectedValue.push(final)
    }
    
    const data = {answers:this.selectedValue, type:'Feedback', message:this.message}
    this.messageService.feedback(data).subscribe( 
      response => {     
        this.presentToast(response.message); 
        this.close();
    },
    error => {
      this.presentToast(error.error.message);       
    })
  }


  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  async close() {
    await this.modalCtrl.dismiss();
  }

  backHome(){
    this.router.navigate(['home']);
  }

}
